/**
 * Audit actor bridge.
 *
 * The Supabase client runs in the browser with the anon key, so Postgres never
 * learns the Clerk identity of the user making a change. We capture the acting
 * employee app-side and expose it to non-React modules (e.g. `recordAudit` in
 * `audit.ts`, called from plain hooks) via this tiny module-level store.
 *
 * `LoggedInEmployeeContext` keeps it in sync — the same side-channel shape as
 * `markSelfEdit` in RecentlyChangedRowsContext.
 */

export interface AuditActor {
  id: string | null;
  email: string | null;
  name: string | null;
}

let currentActor: AuditActor = { id: null, email: null, name: null };

export function setAuditActor(actor: AuditActor): void {
  currentActor = actor;
}

export function getAuditActor(): AuditActor {
  return currentActor;
}
